import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "dr_cookie_consent";

export default function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const v = typeof window !== "undefined" ? localStorage.getItem(KEY) : "ok";
        if (!v) setVisible(true);
    }, []);

    const set = (val) => {
        localStorage.setItem(KEY, val);
        setVisible(false);
    };

    if (!visible) return null;
    return (
        <div
            data-testid="cookie-banner"
            className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:bottom-6 z-[60] max-w-md bg-white border border-dr-silver rounded-2xl shadow-[0_20px_60px_rgba(8,41,74,0.18)] p-5"
        >
            <p className="text-xs uppercase tracking-[0.28em] text-dr-blue font-medium">Privacy</p>
            <h3 className="font-display text-lg text-dr-navy font-semibold mt-1.5">
                We value your discretion.
            </h3>
            <p className="text-sm text-dr-dark/80 mt-2 leading-relaxed">
                We use essential cookies to run the site and optional analytics to improve it. You can change your
                choice at any time.{" "}
                <Link to="/cookies" className="underline text-dr-navy">
                    Read our cookie notice
                </Link>
                .
            </p>
            <div className="flex gap-2 mt-4">
                <button
                    data-testid="cookie-accept"
                    onClick={() => set("all")}
                    className="flex-1 px-4 py-2.5 rounded-full bg-dr-navy text-white text-sm font-medium hover:bg-dr-blue transition-colors"
                >
                    Accept all
                </button>
                <button
                    data-testid="cookie-essential"
                    onClick={() => set("essential")}
                    className="flex-1 px-4 py-2.5 rounded-full border border-dr-silver text-dr-navy text-sm font-medium hover:bg-dr-grey transition-colors"
                >
                    Essential only
                </button>
            </div>
        </div>
    );
}
